export enum PATTERN_KIND {
  pattern700 = "pattern700",
  pattern800 = "pattern800",
}
